// extracted by mini-css-extract-plugin
export default {"popup_container":"modal_popup_popup_container__C7Whq","popup_body":"modal_popup_popup_body__9TWlC"};